import { PuzzlePiece } from "./PuzzlePiece";

export class Slot extends Phaser.GameObjects.Zone {
    id: number;
    position: Phaser.Math.Vector2;
    filled: boolean;

    constructor(scene: Phaser.Scene, x: number, y: number, width: number, height: number, id: number, position: Phaser.Math.Vector2) {
        super(scene, x + width / 2, y + height / 2, width, height);
        this.id = id;
        this.position = position;
        this.filled = false;

        var dropzoneThresholdDistance = 70;

        // this.setOrigin(0);
        this.setRectangleDropZone(this.width - dropzoneThresholdDistance, this.height - dropzoneThresholdDistance);

        // Debug - draw the actual hit area
        // var graphics = scene.add.graphics().lineStyle(2, 0x000000)
        //     .strokeRect(this.x + this.input.hitArea.x, this.y + this.input.hitArea.y,
        //         this.input.hitArea.width, this.input.hitArea.height);

        // scene.add.existing(graphics);
        scene.add.existing(this);
    }
}



// WEBPACK FOOTER //
// ./src/games/JigsawPuzzleGame/objects/Slot.ts